import { render, staticRenderFns } from "./newPayUserKeep.vue?vue&type=template&id=378a7ee1&"
import script from "./newPayUserKeep.vue?vue&type=script&lang=js&"
export * from "./newPayUserKeep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378a7ee1')) {
      api.createRecord('378a7ee1', component.options)
    } else {
      api.reload('378a7ee1', component.options)
    }
    module.hot.accept("./newPayUserKeep.vue?vue&type=template&id=378a7ee1&", function () {
      api.rerender('378a7ee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/userAnalysis/newPayUserKeep.vue"
export default component.exports